var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 17.25V6.25649L22.0001 6.23549C22 5.27697 21.2229 4.5 20.2644 4.5H3.73592C2.78812 4.5 2.01781 5.25972 2.00061 6.20334C2.00021 6.2135 2 6.22372 2 6.23398V17.25C2 18.4926 3.00736 19.5 4.25 19.5H19.75C20.9926 19.5 22 18.4926 22 17.25ZM3.5 16.4977V8.187L10.7134 13.2171C11.4866 13.7563 12.5141 13.7563 13.2873 13.2171L20.5 8.18747V16.4994L16.7127 12.6572L15.4645 13.5276L19.8644 17.9913C19.8271 17.997 19.7889 18 19.75 18H4.25C4.21062 18 4.17194 17.997 4.1342 17.9911L8.53477 13.5267L7.28655 12.6562L3.5 16.4977ZM20.5 6.23398L20.5 6.2286C20.4963 6.10171 20.3922 6 20.2644 6H3.73592C3.60577 6 3.50028 6.10553 3.50032 6.23568C3.50035 6.31268 3.538 6.38481 3.60116 6.42885L11.5713 11.9867C11.8291 12.1664 12.1716 12.1664 12.4293 11.9867L20.3992 6.42905C20.4604 6.38643 20.4976 6.31753 20.5 6.24336V6.23398Z",
    fill: "#323544"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.fb7a6eff117b0fc853ea6bce55fbaa3f.svg";
export { ForwardRef as ReactComponent };